import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';
import { __DEV__ } from '~src/config';

import { DbShare } from '~src/types/db';
import {
  loadSharedAdminTenders,
  TenderSharesListParams,
} from '~src/services/api/shares';
import { QueryKeys } from './queryKeys';

export const useTenderSharesList = (
  params: TenderSharesListParams = {},
  queryConfig: QueryConfig<DbShare[], AxiosError> & {
    enabled?: boolean;
  } = {}
) => {
  const { enabled, ...options } = queryConfig;
  // if enabled = undefined then enabled = true
  const enabledOverwrite = enabled || enabled === undefined;

  const tenders = useQuery<DbShare[], AxiosError>(
    [QueryKeys.tenderAdminSharedTender, params],
    (_, params) => loadSharedAdminTenders(params),
    {
      enabled: enabledOverwrite,
      refetchOnWindowFocus: false,
      ...options,
    }
  );

  return tenders;
};
